export default __webpack_public_path__ + "static/media/logo-white.871870f2.png";